import { render, staticRenderFns } from "./selectConsult.vue?vue&type=template&id=bf639eb2&"
import script from "./selectConsult.vue?vue&type=script&lang=js&"
export * from "./selectConsult.vue?vue&type=script&lang=js&"
import style0 from "./selectConsult.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports